import React from "react";
import { useTranslation } from "react-i18next";
import SFIconButton from "../../button/iconButton";
import { SFSettingsIcon } from "../../icons";

const SFDataGridSettingsButton = ({ onClick }) => {
  const { t } = useTranslation();
  return (
    <SFIconButton
      type="button"
      onClick={onClick}
      ariaLabel={t("components.datagrid.settingsDrawer.header")}
      size="small"
    >
      <SFSettingsIcon color={"grey500"} sx={{ fontSize: "18px" }} />
    </SFIconButton>
  );
};

export default SFDataGridSettingsButton;
